module.exports = __webpack_public_path__ + "img/PRNT_06_mono_AE_00000.74d8ec46.png";